import { FunctionComponent } from 'preact';
import { useCallback } from 'preact/hooks';

import { IconButton, IconButtonProps } from '../IconButton/IconButton';
import { usePlayerFullscreen } from '../../hooks/usePlayerFullscreen';
import { useKeyboardHandler } from '../../hooks/useKeyboardHandler';
import { useCast } from '../../hooks/CastProvider';
import { useTracker } from '../../hooks/useTracker';
import { useIcons } from '../../hooks/useIcons';
import { useTpaasTracker } from '../../hooks/useTpaasTracker';

export const FullscreenButton: FunctionComponent<IconButtonProps> = (props) => {
  const { trackEngagementUIElement } = useTpaasTracker();
  const { isFullscreen, toggleFullscreen } = usePlayerFullscreen();
  const { isActive } = useCast();
  const { trackButtonClick } = useTracker();

  const handleClick = useCallback(
    (e: MouseEvent) => {
      e.stopPropagation();
      toggleFullscreen();
      trackButtonClick('fullscreen');
      if (e.currentTarget instanceof Element) {
        trackEngagementUIElement({
          elementName: `${isFullscreen ? 'Stop' : 'Start'} Fullscreen`,
          elementType: e.currentTarget.tagName.toLowerCase(),
          name: 'Fullscreen',
        });
      }
    },
    [toggleFullscreen, trackButtonClick, isFullscreen, trackEngagementUIElement]
  );

  const handleKeydown = useCallback(
    (e: KeyboardEvent) => {
      if (isActive) {
        return;
      }

      if (e.code === 'KeyF') {
        toggleFullscreen();
      }
    },
    [isActive, toggleFullscreen]
  );

  useKeyboardHandler(handleKeydown);

  if (isActive) {
    return null;
  }
  const { Maximize } = useIcons();

  return (
    <IconButton onClick={handleClick} {...props}>
      <Maximize />
    </IconButton>
  );
};
